import Mention from '@tiptap/extension-mention'
import suggestion from './member_suggestion'

export const ExtendedMention = Mention.extend({
  name: 'memberMention',
  addOptions() {
    const parent = this.parent?.() ?? {}

    return {
      ...parent,
      url: null,
      suggestion: {
        ...parent.suggestion,
        command: ({ editor, range, props }) => {
          editor
            .chain()
            .focus()
            .insertContentAt(range, [
              { type: 'memberMention', attrs: props },
              {
                type: 'text',
                text: ' ​', // This has a zero-width space after the normal space so tiptap doesn't cause problems without having to use white-space: pre-wrap
              },
            ])
            .run()
        },
      },
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      mentionMemberId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-mention-member-id'),
        renderHTML: (attributes) => {
          return { 'data-mention-member-id': attributes.id }
        },
      },
    }
  },
}).configure({
  HTMLAttributes: {
    class: 'mention',
  },
  suggestion,
})
